import { render, staticRenderFns } from "./MaterialAttributeEditDialog.vue?vue&type=template&id=f7930408&scoped=true"
import script from "./MaterialAttributeEditDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialAttributeEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialAttributeEditDialog.vue?vue&type=style&index=0&id=f7930408&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7930408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7930408')) {
      api.createRecord('f7930408', component.options)
    } else {
      api.reload('f7930408', component.options)
    }
    module.hot.accept("./MaterialAttributeEditDialog.vue?vue&type=template&id=f7930408&scoped=true", function () {
      api.rerender('f7930408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/MaterialAttributeEditDialog.vue"
export default component.exports